import { render, staticRenderFns } from "./Toasts.vue?vue&type=template&id=cb453234&scoped=true&"
import script from "./Toasts.vue?vue&type=script&lang=js&"
export * from "./Toasts.vue?vue&type=script&lang=js&"
import style0 from "./Toasts.vue?vue&type=style&index=0&id=cb453234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb453234",
  null
  
)

export default component.exports